// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1583) return "static/chunks/1583-2038719459b5e0ab.js";
	if (chunkId === 5346) return "static/chunks/5346-830cd454bf6ccd67.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"75":"6d4d902059583e7a","6588":"677dbfc8a89a14fe","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};